import { Breadcrumb } from "../breadcrumb.model";

export class GenerateBreadcrumbUseCaseResponse{
    breadcrumbItems: Breadcrumb[] = [];
}